import ErrorCollector from './ErrorCollector';

class StartColumnCollector extends ErrorCollector<number, number> {
  constructor() {
    super((...[_recognizer, _offendingSymbol, _line, column, _message, _error]) => column);
  }
}

export default StartColumnCollector;
